import request from '@/utils/request'

export function lczOALogin(data) {
  return request({
    url: '/lcz/lczOALogin',
    method: 'post',
    data
  })
}

export const APIBASEURL=process.env.BASE_API


// WEBPACK FOOTER //
// ./src/api/lcz.js